import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  objDescriptionclass: (props) =>
    !props.mediaquery
      ? {
          textAlign: "center",
          width: "100%",
          justifyContent: "center",
        }
      : {},
});

export default useStyles;
